import { HtmlText } from '@Components/BigBrowse/GridCardMesh/Components/Texts/HtmlText';
import { convertToHtmlTextProps } from '@Components/BigBrowse/GridCardMesh/Components/Texts/texts.common';
import type { ParagraphView } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/MultiSectionView.types';
import { Box } from '@react-three/flex';
import { observer } from 'mobx-react-lite';

type Props = {
  view: ParagraphView;
  marginTop?: number;
};

export const HeroAndTextParagraph = observer(function HeroAndTextParagraph({
  view,
  marginTop = 0,
}: Props) {
  const props = convertToHtmlTextProps(view.props);

  return (
    <Box
      width={view.size.width}
      height={view.size.height}
      centerAnchor
      marginTop={marginTop as number}
    >
      <HtmlText
        size={{ width: view.size.width, height: view.size.height }}
        {...props}
      />
    </Box>
  );
});
